import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["description", "imageSrc", "name", "slug", "use"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { generatePath } from 'react-router-dom';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { Paths } from '../constants/paths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionCard(_ref) {
  let {
      // TODO: consume collectionId from props
      // collectionId,
      description,
      imageSrc,
      name,
      slug,
      use = 'default'
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-test-id": "ecosystem-collection-card",
    blockSize: "100%",
    children: /*#__PURE__*/_jsxs(Flex, Object.assign({
      backgroundColor: use === 'on-dark' ? 'fill-surface-default' : 'fill-surface-raised',
      borderRadius: "100",
      gap: "800",
      padding: "800"
    }, restProps, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        flexDirection: "column",
        flexGrow: "1",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          children: name
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockStart: "200",
          marginBlockEnd: "400",
          children: description
        }), /*#__PURE__*/_jsx(UIRouterButton, {
          onClick: () => {
            // TODO: track interaction
            window.scrollTo(0, 0);
          },
          to: generatePath(Paths.FEATURED_COLLECTION, {
            collectionSlug: slug
          }),
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.collectionCard.viewCollection"
          })
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        flexShrink: "0",
        children: /*#__PURE__*/_jsx(Image, {
          src: imageSrc,
          inlineSize: "150px",
          objectFit: "contain"
        })
      })]
    }))
  });
}